<template>
    <div class="d-flex flex-column" :class="{'ready' : mounted}">
        <div class="my-auto text-center" v-if="onLoading && !mounted">
                <i class="fas fa-spinner fa-pulse fa-3x fa-fw"></i>
                <span class="sr-only">Caricamento...</span>
        </div>
        <div class="d-flex h-100 flex-column" v-if="mounted">
            <div class="d-flex justify-content-between align-items-center alert alert-danger" v-if="error">
                <i class="far fa-frown fa-3x mr-4"></i>
                <div class="w-100">
                    <p class="mb-0">Qualcosa è andato storto</p>
                    <a :href="medico.url">Ricarica la pagina</a>
                </div>
            </div>

            <div v-if="!error">
                <div v-if="!listStudi.length">
                    <div class="my-4">
                        <p class="lead mb-0 w-100 text-center">
                            <i class="fas fa-exclamation-circle d-block"></i>
                        </p>

                        <p v-if="!clinicheMedicoCount || !medicoRichiedibile" class="lead text-center my-3">
                            Il Medico non è attualmente disponibile per la prenotazione online
                        </p>

                        <template v-if="medicoRichiedibile">
                            <p v-if="clinicheMedicoCount" class="pt-4">
                            {{ medico.preposizioneIl }} <strong>{{ medico.fullName }}</strong> è disponibile <template v-if="clinicheMedicoCount == 1">presso <strong>{{ clinicheMedico[0].nome }}</strong></template> solo su richiesta.
                            </p>

                            <div v-if="clinicheMedicoCount > 1">
                                <div class="mt-4">
                                    <div class="mb-4 text-center pb-3 border-bottom rfs-7 font-weight-bold">Scegli la struttura</div>
                                    <div class="form-check mt-2" v-for="(v, k) in clinicheMedico" :key="k + 'list-cliniche-select'">
                                        <input class="form-check-input" type="radio" name="id_clinica_choose" :value="v.id_clinica" :id="k" v-model="sedeRichiesta">
                                        <label class="form-check-label" :for="k">
                                            {{ v.nome }}
                                            <span class="d-block w-100 small text-muted">
                                                (<span v-for="(vv, kk) in provinceStudiCliniche[v.id_clinica]" :key="'lst-strutture' + v.id_clinica + '-' + kk"><span v-if="kk != 0">, </span>{{ vv }}</span>)
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <RichiediDisponibilita
                                :idMedico="medico.ID"
                                :idClinica="sedeRichiesta"
                                :idStudio="idStudio"
                                :idPrestazione="idPrestazione"
                            />

                            <em v-if="clinicheMedicoCount" class="text-muted">sarai ricontattato dalla segreteria per concordare un appuntamento.</em>
                        </template>

                        <template v-if="linksOtherMedici.length">
                            <hr />
                            <p class="lead">Altri Medici Specialisti</p>
                            <ul>
                                <li v-for="(v, k) in linksOtherMedici" :key="'list-altri-medici' + k" class="py-3 py-lg-2"><a class="rfs-7" :href="v.url">{{ v.title }}</a></li>
                            </ul>
                        </template>

                        <!-- @todo Scrivi al medico: al momento è stato disabilitato -->
                    </div>
                </div>

                <div v-else>
                    <div class="prestazione-wrapper">
                        <div class="prestazione-title">
                            {{ prestazione.scorciaNome }}
                            <span v-if="keyword">
                                <small class="d-block">
                                    per <b>{{ keyword.keyword | ucfirst }}</b>
                                </small>
                            </span>
                        </div>
                        <div class="prezzo">
                            <span :class="{'strikethrough' : existPromotion}" class="rfs-9 font-weight-bold">{{ prezzoPrestazione }}</span>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between text-promo" v-if="existPromotion">
                        <div class="w-100">
                            Scontato dal <span class="text-capitalize">{{ existPromotion.datainizio | mydate('DD MMM') }}</span> al <span class="text-capitalize">{{ existPromotion.datafine | mydate('DD MMM YY') }}</span>
                        </div>
                        <div class="w-auto text-nowrap font-weight-bold">{{ prezzoPrestazionePromo }}</div>
                    </div>        
                    <div v-if="mostraPagamentoAnticipato && prezzoPagamentoOnline">
                        <p class="d-flex justify-content-between text-muted small my-2 ">
                            <i class="fas fa-credit-card mt-1" data-toggle="tooltip" data-placement="top" :title="'Possibilità di pagare in anticipo con carta di credito, a tariffa agevolata di ' + prezzoPagamentoOnline  + ' €'" aria-hidden="true"></i>
                            <span class="w-100 ml-2">
                                Risparmia il {{ studio.pagamento_anticipato_sconto }}% pagando online
                                <span class="d-block small">
                                    (Scegli <em>"Paga in anticipo con carta"</em> alla conferma)
                                </span>
                            </span>
                        </p>
                    </div>
                    <div class="mb-2" v-if="listPrestazioni.length > 1">
                        <button class="btn btn-link btn-sm text-decoration-underline p-0" @click="showAllPrest()">Cambia prestazione</button>
                    </div>
                    <div class="alert alert-warning mx-n2 mx-md-n3 mb-0 small px-2" v-if="warningPrestazione">
                        <i class="fas fa-exclamation-circle" aria-hidden="true"></i> {{ warningPrestazione}}
                    </div>
                    <div class="alert alert-warning small mx-n2 mx-md-n3 cont-wrapper mb-0 mt-2 px-2" v-if="studio.prestazioni[0].introNote">
                        <b>Note/Prescrizioni:</b> <span v-html="studio.prestazioni[0].introNote"></span>
                        <span v-if="studio.prestazioni[0].nextIntroNote">
                            <span class="continua">[...]</span>
                            <span class="continuazione"><span v-html="studio.prestazioni[0].nextIntroNote"></span> <span class="cont-close">Chiudi</span></span>
                        </span>
                    </div>
                    <div class="alert alert-warning mx-n2 mx-md-n3 mb-0 px-2" v-if="studio.tipo == 3 && prezzoPagamentoOnline > 0">
                        <b>Nota bene:</b> Per effettuare un VideoConsulto è richiesto il pagamento anticipato tramite carta di credito
                    </div>
                    <hr class="mx-n2 mx-md-n3 my-0"/>
                    <div v-if="(existVideoconsulto + existDomicilio + existStudio) > 1">
                        <ul class="studio-tabs nav nav-tabs mt-2 flex-nowrap" role="tablist" :id="'tab-' + medico.ID">
                            <li v-for="(s, k) in studiTypes" :key="'list-types-studi' + k" class="nav-item" role="presentation" v-if="s.list.length">
                                <a
                                    class="nav-link tab-studio"
                                    :id="'tab_studi_medico_' + k"
                                    data-toggle="tab"
                                    :href="'#studi_medico_' + k"
                                    type="button"
                                    role="tab"
                                    @click="selectStudio(s.list[0].ID, s.list[0].tipo)"
                                    :aria-controls="'studi_medico_' + k"
                                    :aria-selected="s.is_current"
                                    :class="{'active' : s.is_current}"
                                    >{{ k }}</a>
                            </li>
                        </ul>
                    </div>

                    <div class="tab-content">
                        <div 
                            v-for="(studi, k) in studiTypes"
                            :class="[{
                                'tab-pane fade mb-n2': existVideoconsulto || existDomicilio,
                                'active show': studi.is_current
                            }]"
                            :id="'studi_medico_' + k"
                            :key="'studi_medico_' + k"
                        >
                            <div 
                                @click="selectStudio(s.ID)"
                                class="studio-detail"
                                v-if="s.tipo != 3"
                                :class="[
                                    {
                                        'active' : s.ID == studio.ID,
                                    },
                                    s.collapsed && !showAllStudi ? 'collapse' : 'not-collapsed'
                                ]"
                                v-for="(s, k) in studi.list"
                                :key="'list-studi-type' + k"
                                :id="'studio_medico_' + s.ID"
                            >

                                <div class="wrapper-studio">
                                    <div>
                                        <div>
                                            <span v-html="s.labelStudioDisponibilita"></span>
                                        </div>
                                        <div class="text-muted small studiovia">
                                            <template v-if="s.ID == studio.ID && (studio.tipo == 1 || studio.parcheggio || studio.modalita_pagamento)">
                                                <button data-toggle="modal" data-target="#detailStudioModal-real" type="button" class="btn btn-link text-muted btn-sm p-0 text-decoration-underline d-block">
                                                {{ s.via }} <i class="fas fa-fw fa-info-circle" aria-hidden="true"></i>
                                                </button>
                                            </template>
                                            <template v-else>
                                                {{ s.via }}
                                            </template>
                                            <div v-if="s.pressoClinica" class="font-weight-normal small text-muted mt-1">
                                                {{ s.pressoClinica }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="s.tipo != 3 && s.prestazioni.length && showAllStudi" class="call-to-action">
                                        <b :class="{'strikethrough': s.promozioni && s.promozioni.length}" class="ml-auto ml-lg-0 align-self-end pr-md-0 pr-lg-1 text-nowrap">{{ studioPrezzoPrestazione(s.prestazioni[0].prezzo1, s.prestazioni[0].prezzo2) }}</b>
                                        <template v-if="s.promozioni && s.promozioni.length">
                                            <br>
                                            <b class="text-promo">{{ s.promozioni[0].prestazioni[0].prezzoscontato }} €</b>
                                        </template>
                                    </div>
                                </div>

                            </div>
                            <div v-if="studi.list.length > num_studi_visibili" class="mt-1 text-right">
                                <button class="btn btn-link btn-sm p-0 text-decoration-underline" @click="showAllStudi = !showAllStudi">
                                    <span v-if="!showAllStudi">Vedi</span><span v-if="showAllStudi">Nascondi</span> altri studi
                                </button>
                            </div>
                        </div>
                        <hr v-if="studio.tipo != 3" class="mx-n2 mx-md-n3" />
                    </div>
                    <div class="mt-3">
                        <small class="text-muted d-block font-weight-bold text-uppercase text-center mb-2">Scegli giorno e orario</small>
                        <Calendario
                            v-if="listDisp.length"
                            :disponibilita="listDisp"
                            :idMedico="idMedico"
                            :idPrestazione="idPrestazione"
                            :idStudio="idStudio"
                            :idKeyword="idKeyword"
                            :idClinica="idClinica"
                            :startFromDate="startFromDate"
                            :idSpecializzazione="idSpecializzazione"
                            :cols="cols"
                            :visibleHoursBeforeHide="8"
                            :promozioni="promozioni"
                            :groupCollapse="true"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" v-if="studio" id="detailStudioModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-white">
                        <h6 class="modal-title" v-html="'Info su ' + (studio.tipo == 1 ? 'studio a ' : '') + '<strong>' + studio.labelStudioTitle + '</strong>'"></h6>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-4" v-if="studio.tipo == 2">
                            <span class="d-block">
                                {{ studio.presso2 }}
                            </span>
                        </div>
                        <div class="mb-4" v-if="studio.tipo == 1">
                            <p class="font-weight-bold mb-2"><small class="fas fa-fw fa-location-arrow" aria-hidden="true"></small> {{ studio.via }}</p>
                            <span class="d-block">
                                
                                <span v-if="(studio.presso && !studio.id_parent) || (studio.pressoClinica && studio.id_parent)" class="d-block mt-2 text-muted">{{ studio.id_parent ? studio.pressoClinica : studio.presso.replace(/,$/, '') }}</span>
                            </span>
                            <div class="my-3 mappacontainer">
                                <div class="mappastudio"></div>
                            </div>
                        </div>

                        <div class="mb-4" v-if="studio.parcheggio">
                            <p class="font-weight-bold mb-2"><i class="fas fa-fw fa-car" aria-hidden="true"></i> Dove parcheggiare?</p>
                            <span class="d-block">
                                {{ studio.parcheggioLabel }}
                            </span>
                        </div>

                        <div class="mb-4" v-if="studio.pagamentiLabel && studio.pagamentiLabel.length">
                            <p class="font-weight-bold mb-2"><i class="fas fa-fw fa-money-bill" aria-hidden="true"></i>  Modalità di pagamento</p>
                            <span v-for="(m, k) in studio.pagamentiLabel" :key="'list-tipo-pagamenti' + k">{{ m.value }} {{k != (studio.pagamentiLabel.length - 1) ? ', ' : null}} </span>
                        </div>

                        <div class="mb-4" v-if="studio.tipo == 1">
                            <p class="font-weight-bold mb-2"><i class="fas fa-fw fa-wheelchair" aria-hidden="true"></i>  Accessibilità</p>
                            {{ studio.accessibilitaLabel }}
                        </div>

                    </div>
                    <div class="modal-footer justify-content-end d-none d-lg-block">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Chiudi</button>
                    </div>
                </div>
            </div>
        </div>
        <div :class="[showOtherPrest ? 'd-flex justify-content-center align-items-end' : 'd-none']" id="all-prest" @click="hideALlPrest()">
            <div class="d-block p-2 wrapper-prestazioni border-top rounded-top bg-white" :class="{'active': readyOtherPrest}" @click="$event.stopPropagation()">
                <div class="d-block h-100 wrapper-prestazioni-overflow position-relative">
                    <div class="d-block">
                        <div class="header">
                            <h5 class="d-flex justify-content-between align-items-center border-bottom">Scegli una prestazione <button @click="hideALlPrest()" type="button" class="btn btn-sm btn-default">Chiudi</button></h5>
                            <p>Filtra per:
                                <span class="badge" @click="filterPrest = 'piu_prenotate'" :class="[filterPrest == 'piu_prenotate' ? 'badge-primary' : 'badge-light']" role="button">Le più prenotate</span>
                                <span class="badge" @click="filterPrest = 'all'" :class="[filterPrest == 'all' ? 'badge-primary' : 'badge-light']" role="button">Tutte</span>
                                <span class="badge" v-if="existVideoconsultoFilter" @click="filterPrest = 'videoconsulti'" :class="[filterPrest == 'videoconsulti' ? 'badge-primary' : 'badge-light']" role="button">Videoconsulti</span>
                            </p>
                        </div>
                        <div class="d-block">
                            <ul class="list-unstyled">
                                <li role="button" class="d-flex justify-content-between align-items-center border-bottom py-2" @click="selectPrestazione(p)" v-for="(p, k) in listPrestazioniFiltered" :key="'list-prestazioni-filtered' + k">
                                    <p class="mb-0">
                                        {{ p.nome }}
                                    </p>
                                    <button type="button" style="max-width:90px" class="btn btn-block btn-primary btn-block text-nowrap ml-4">
                                        {{ p.testo_da + p.prezzo_da }} €
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="modal fade modelPrestazioni modal-body-fixed" v-if="studio" id="modelPrestazioni" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="row" v-if="medico">
                            <div class="col-12 d-flex">
                                <div class="d-flex flex-row align-items-center">
                                    <img :src="medico.listFoto[1]" width="120" height="120" class="img-fluid foto-medico rounded-circle img-fit" :title="medico.fullName"/>
                                    <div class="w-auto ml-3">
                                        <strong class="h3">{{ medico.fullName }}</strong>
                                        <div class="text-muted">Scelta della prestazione</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body p-0">
                        <div class="p-2 bg-gray-200">
                            <h4 class="mb-0">Prestazioni più prenotate</h4>
                        </div>
                        <div class="d-flex justify-content-between align-items-center border-top p-2 pl-3" :onclick="'selectPrestazione('+ p.ID + ')'" @click="selectPrestazione(p)" v-for="(p, k) in listPrestazioniFilteredMostBooked" :key="k+'-most'">
                            <p class="mb-0">
                                {{ p.nome }}
                            </p>
                            <button type="button" style="max-width:90px" class="btn btn-block btn-primary btn-block text-nowrap ml-4">
                                {{ p.testo_da + p.prezzo_da }} €
                            </button>
                        </div>
                        <div class="p-2 bg-gray-200 sticky-top mr-0">
                            <h4 class="mb-0">Tutte le prestazioni</h4>
                        </div>
                        <div id="allPrestMedico">
                            <div class="d-flex justify-content-between align-items-center border p-2 pl-3" :onclick="'selectPrestazione('+ p.ID + ')'" @click="selectPrestazione(p)" v-for="(p, k) in listPrestazioni" :key="k+'-all'">
                                <p class="mb-0">
                                    {{ p.nome }}
                                </p>
                                <button type="button" style="max-width:90px" class="btn btn-block btn-primary btn-block text-nowrap ml-4">
                                    {{ p.testo_da + p.prezzo_da }} €
                                </button>
                            </div>
                        </div>

                        <template v-if="existVideoconsultoFilter">
                            <div class="p-2 bg-gray-200 text-center">
                                <h3 class="mb-0"><i class="fas fa-video" aria-hidden="true"></i> Videoconsulti</h3>
                            </div>
                            <div class="d-flex justify-content-between align-items-center border p-2" :onclick="'selectPrestazione('+ p.ID + ')'" @click="selectPrestazione(p)" v-for="(p, k) in listPrestazioniFilteredVideoconsulti" :key="k+'-video'">
                                <p class="mb-0">
                                    {{ p.nome }}
                                </p>
                                <button type="button" style="max-width:90px" class="btn btn-block btn-primary btn-block text-nowrap ml-4">
                                    {{ p.testo_da + p.prezzo_da }} €
                                </button>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer justify-content-end">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Chiudi</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Calendario from "./Calendario";
import RichiediDisponibilita from "./RichiediDisponibilita";

export default {
    components: {
        Calendario,
        RichiediDisponibilita
    },
    props: {
        idMedico: null,
        idPrestazione: null,
        idStudio: null,
        idKeyword: null,
        idClinica: null,
        idSpecializzazione: null,
        startFromDate: null,
    },
    data: function() {
        return {
            mounted: false,
            curIdMedico: null,
            curIdPrestazione: null,
            curIdStudio: null,
            curIdKeyword: null,
            onLoading: false,
            showAllStudi: false,
            medico: null,
            showOtherPrest: false,
            readyOtherPrest: false,
            listPrestazioni: [],
            filterPrest: 'piu_prenotate',

            disponibile: false,
            error: null,
            keyword: null,
            listDisp: [],
            listStudi: [],
            mostraPagamentoAnticipato: false,
            num_studi_visibili: 2,
            prestazione: null,
            promozioni: [],
            studio: null,
            existPromotion: null,
            prezzoPagamentoOnline: null,
            warningPrestazione: null,
            currentDay: null,

            clinicheMedicoCount: 0,
            clinicheMedico: [],
            sedeRichiesta: null,
            provinceStudiCliniche: [],
            linksOtherMedici: [],
            medicoRichiedibile: false,
            cols: 5,

            studiTypes : {},
            existVideoconsulto: 0,
            existDomicilio: 0,
            existStudio: 0,
            map: null,
        };
    },
    computed: {
        prezzoPrestazione: function() {
            if (! this.studio) return null;

            return this.studioPrezzoPrestazione(this.studio.prestazioni[0].prezzo1, this.studio.prestazioni[0].prezzo2);
        },

        prezzoPrestazionePromo: function() {
            if (!this.existPromotion) return null;
            return this.existPromotion.prestazioni[0].prezzoscontato + ' €';
        },

        currentDisponibilita: function() {
            if (!this.listDisp.length) return [];

            const disp = this.listDisp.find(d => d.giorno == this.currentDay);
            if (!disp) return [];
            return disp.listOrari;
        },

        existVideoconsultoFilter: function() {
            return this.listPrestazioni.find(p => p.is_videoconsulto) ? true : false;
        },

        listPrestazioniFilteredMostBooked: function() {
            return this.listPrestazioni.filter(p => p.mostBooked).sort((a, b) => a.ID > b.ID ? 1 : -1);
        },
        listPrestazioniFilteredVideoconsulti: function() {
            return this.listPrestazioni.filter(p => p.is_videoconsulto);
        },
        listPrestazioniFiltered: function() {
            if (!this.listPrestazioni.length) return [];
            if (this.filterPrest == 'all') return this.listPrestazioni;
            if (this.filterPrest == 'videoconsulti') return this.listPrestazioni.filter(p => p.is_videoconsulto);
            return this.listPrestazioni.filter(p => p.mostBooked).sort((a, b) => a.ID > b.ID ? 1 : -1);
        }
    },
    mounted() {
        this.curIdMedico = this.idMedico;
        this.curIdPrestazione = this.idPrestazione;
        this.curIdStudio = this.idStudio;
        this.curIdKeyword = this.idKeyword;

        this.requestDisponibilita();

        window.addEventListener('resize', () => {
            //distinct between mobile, tablet and desktop
            if (window.innerWidth < 420) {
                this.cols = 3;
            }
            else if (window.innerWidth < 576) {
                this.cols = 5;
            }
            else if (window.innerWidth < 992) {
                this.cols = 6;
            } else {
                this.cols = 5;
            }
        });

        //call resize
        window.dispatchEvent(new Event('resize'));
    },
    methods: {
        studioPrezzoPrestazione: function(prezzo1, prezzo2) {
            
            let label = 'GRATIS';
            if (prezzo1) {
                label = prezzo1 + ' €';

                if (prezzo1 != prezzo2) {
                    label = 'da ' + label;
                }
            }
            return label;
        },
        selectStudio: function(idStudio, tipo) {
            const curTipo = this.studio.tipo;
            if (curTipo != tipo) {
                if (tipo == 3 || curTipo == 3) {
                    this.curIdPrestazione = null;
                }
            }
            this.curIdStudio = idStudio;
            this.showAllStudi = false;
            this.scrollCalendarToView();
        },
        selectPrestazione: function(p) {
            this.curIdPrestazione = p.ID;
            let existStudio = false;
            if (p.listStudi && p.listStudi.length) {
                existStudio = p.listStudi.find(s => s.ID == this.curIdStudio);
            }

            if (!existStudio) {
                const existStudi = this.listPrestazioni.find(pre => pre.ID == p.ID && pre.listStudi.length && pre.listStudi.find(s => s.ID == this.curIdStudio));
                if (!existStudi) {
                    this.curIdStudio = null;
                }
            }
            this.hideALlPrest();
        },

        hideALlPrest: function() {
            return $('#modelPrestazioni-real').modal('hide');
            this.readyOtherPrest = false;
            setTimeout(() => {
                $('body').removeClass('all-prest-open');
                this.showOtherPrest = false;
            }, 500);
        },

        showAllPrest: function() {
            $('#modelPrestazioni-real').remove();
            return setTimeout(() => {
                $('#modelPrestazioni').clone().appendTo('body').attr('id', 'modelPrestazioni-real');
                $('#modelPrestazioni-real').modal('show');
            }, 200);
        },
        existStudioPromotion: function(studio) {
            if (this.promozioni.length) {
                const existIsValidPromotion =  this.promozioni.filter(c => c.prestazioni.find(p => p.id_studi == studio.ID)).map(c => {
                    c = c;
                    c.prestazioni = c.prestazioni.filter(p => p.id_studi == studio.ID);
                    return c;
                });
                if (!existIsValidPromotion.length) return false;

                for(const k in this.listDisp) {
                    const disp = this.listDisp[k];

                    const existPromotion = existIsValidPromotion.find(c => c.datainizio.isSameOrBefore(disp.giorno) && c.datafine.isSameOrAfter(disp.giorno));
                    /**
                     * In questo caso sto controllando il corrente, quindi mi salvo in memoria il dato
                     */
                    if (existPromotion) {
                        if (existPromotion && studio.ID == this.studio.ID) {
                            this.existPromotion = existPromotion;
                            this.prezzoPagamentoOnline = this.existPromotion.prestazioni[0].prezzoscontato;

                        }
                        return existPromotion;
                    }
                }
            }
            return false;
        },
        scrollCalendarToView() {
            //@todo scroll only if studio is not visible and in mobile
            //check if mobile otherwise scrollIntoView will scroll the page
            if (window.innerWidth > 768) return;
            const el = document.querySelector('#medico-box-orari');
            if (! el) return;
            el.scrollIntoView({behavior: 'smooth', block: 'start'});
        },
        requestDisponibilita: function() {
            this.onLoading = true;

            httpRequest(api_url + 'frontend/medico/disponibilita', {
                    idMedico: this.curIdMedico,
                    idPrestazione: this.curIdPrestazione,
                    idStudio: this.curIdStudio,
                    idKeyword: this.curIdKeyword,
                    idClinica: this.idClinica,
                }, {showLoader: this.mounted}).then(onResult => {

                if (!onResult.result) {
                    console.log('noresult');
                    return;
                }

                this.medico = onResult.data.medico;
                this.medicoRichiedibile = this.medico.medicoRichiedibile;
                this.disponibile = onResult.data.disponibile;
                this.error = onResult.data.error;

                if (this.error) {
                    console.log('this.error', this.error);
                    return;
                }

                this.keyword = onResult.data.keyword;
                
                this.listStudi = onResult.data.listStudi;
                this.studiTypes = {
                    Studio: {
                        is_current: false,
                        list: []
                    },
                    Domicilio: {
                        is_current: false,
                        list: []
                    },
                    Online: {
                        is_current: false,
                        list: []
                    }
                };
                
                this.mostraPagamentoAnticipato = onResult.data.mostraPagamentoAnticipato;
                this.num_studi_visibili = onResult.data.num_studi_visibili;
                this.prestazione = onResult.data.prestazione;
                this.listPrestazioni = onResult.data.listPrestazioni || [];

                const promos = {};
                onResult.data.promozioni.forEach(promozione => {
                    promozione.prestazioni.forEach(prestazione => {
                        if (!promos[prestazione.id_studi]) {
                            promos[prestazione.id_studi] = [];
                        }
                        promos[prestazione.id_studi].push(promozione);
                    });
                });
                
                this.studio = onResult.data.studio;

                this.listStudi.forEach(s => {
                    s.is_current = s.ID == this.studio.ID;
                    let currentType = null;
                    if (promos[s.ID]) {
                        s.promozioni = promos[s.ID];
                        if (this.studio.ID == s.ID) {
                            this.promozioni = promos[s.ID];
                        }
                    }
                    
                    switch(s.tipo) {
                        case 1:
                            currentType = 'Studio';
                            this.existStudio = 1;
                         break;
                        case 2:
                            currentType = 'Domicilio';
                            this.existDomicilio = 1;
                         break;
                        case 3:
                            currentType = 'Online';
                            this.existVideoconsulto = 1;
                         break;
                    }

                    this.studiTypes[currentType].list.push(s);
                    if (s.is_current) {
                        this.studiTypes[currentType].is_current = true;
                    }
                });
                this.warningPrestazione = onResult.data.warningPrestazione;
                this.curIdMedico = this.medico.ID;

                this.clinicheMedico = onResult.data.medico.clinicheMedico;
                this.clinicheMedicoCount = this.clinicheMedico.length;
                this.provinceStudiCliniche = onResult.data.provinceStudiCliniche;
                this.linksOtherMedici = onResult.data.linksOtherMedici;

                if  (this.clinicheMedicoCount) {
                    this.linksOtherMedici = [];
                }

                if (this.clinicheMedicoCount == 1) {
                    this.sedeRichiesta = this.clinicheMedico[0].id_clinica;
                }

                if (this.curIdPrestazione != this.prestazione.ID) {
                    this.curIdPrestazione = this.prestazione.ID;
                }

                if (this.curIdStudio != this.studio.ID) {
                    this.curIdStudio = this.studio.ID;
                }

                if (this.promozioni.length) {
                    for(const k in this.promozioni) {
                        this.promozioni[k].datainizio = moment(this.promozioni[k].datainizio);
                        this.promozioni[k].datafine = moment(this.promozioni[k].datafine);
                    }
                }

                this.listDisp = onResult.data.listDisp;
                this.currentDay = this.listDisp.length ?  this.listDisp[0].giorno : null;
                this.existPromotion = null;
                this.prezzoPagamentoOnline = null;

                if ( this.mostraPagamentoAnticipato ) {
                    this.prezzoPagamentoOnline = this.studio.prestazioni[0].prezzo2;
                }

                setTimeout(() => {
                    $('[data-toggle="tooltip"]').tooltip();
                    $('.continua').on('click', function() {
                        $(this).hide();
                        $(this).closest('.cont-wrapper').find('.continuazione').fadeIn(300).css('display', 'inline');
                    });

                    $('.cont-close').on('click', function() {
                        $(this).parent('.continuazione').fadeOut(300,function() {
                            $(this).closest('.cont-wrapper').find('.continua').fadeIn(300).css('display', 'inline');
                        });
                    });
                }, 500);

                if (!this.mounted) {
                    this.$watch('curIdPrestazione', function(val) {
                        if(typeof URL === 'function') {
                            const url = new URL(window.location.href);
                            if (typeof url.searchParams != "undefined") {
                                url.searchParams.delete("prestazione");
                                if (val) {
                                    url.searchParams.set("prestazione", val);
                                }
                                window.history.pushState({ path: url.href }, '', url.href);
                            }
                        }
                        if (val) {
                            this.requestDisponibilita();
                        }
                    });

                    this.$watch('curIdStudio', function(val) {
                        if (val) {
                            if(typeof URL === 'function') {
                                const url = new URL(window.location.href);
                                if (typeof url.searchParams != "undefined") {
                                    url.searchParams.set("studio", val);
                                    window.history.pushState({ path: url.href }, '', url.href);
                                }
                            }
                        }
                        this.requestDisponibilita();
                    });
                }
                /**
                 * isseu, le modal non possono stare in un parent con position stiky
                 * https://stackoverflow.com/questions/43452005/bootstrap-modal-wont-display-if-the-position-of-its-parent-container-set-to-fix
                 */
                $('#detailStudioModal-real').remove();
                setTimeout(() => {
                    $('#detailStudioModal').clone().appendTo('body').attr('id', 'detailStudioModal-real');
                    $('#detailStudioModal-real .mappastudio:first').attr('id', 'mappastudio');
                    $('#detailStudioModal-real').on('shown.bs.modal', () => {
                        this.loadMap();
                    });

                    $('#detailStudioModal-real').on('hidden.bs.modal', () => {
                        this.map = null;
                    });

                }, 200);

                this.existStudioPromotion(this.studio);

            }).finally(() => {
                this.onLoading = false;
                this.mounted = true;
            });
       },
       loadMap: async function() {     
            if (this.studio.tipo != 1) {
                return;
            }
            if (! $('#scriptMapps').length) {
                const script = document.createElement('script');
                script.id = 'scriptMapps';
                script.src = base_url+'assets/mappe/leaflet.js';
                script.charset = 'utf-8';

                await new Promise(resolve => {
                    document.body.appendChild(script);
                    script.onload = resolve;
                });
                

                const link = document.createElement('link');
                link.id = 'styleMapps';
                link.rel = 'stylesheet';
                link.type = 'text/css';
                link.href = base_url+'assets/mappe/leaflet.css';

                await new Promise(resolve => {
                    document.head.appendChild(link);
                    link.onload = resolve;
                });   
            }


            const mapIcon = L.icon({
                iconUrl: base_url+"marker.svg",
                iconSize: [29, 40],
                popupAnchor: [0, -20],
            });
            
            if (this.studio && this.studio.latitudine && this.studio.longitudine) {
                this.map = L.map('mappastudio').setView([this.studio.latitudine, this.studio.longitudine], 16);
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    maxZoom: 18,
                }).addTo(this.map);
                L.marker([this.studio.latitudine, this.studio.longitudine], {
                    icon: mapIcon,
                    id: this.studio.ID,
                }).addTo(this.map).bindPopup(this.studio.labelStudioTitle);
                this.map.invalidateSize();
            }
       }
    }
};
</script>
<style lang="scss" type="scoped">
    #mappastudio {
        height: 280px;
        width:100%;
    }
    @media screen and (max-width: 768px) {
        #mappastudio {
            height: 200px;
            height: 30vh;
            height: 30dvh;
        }
        #detailStudioModal {
            max-height: 80%;
            max-height: 80vh;
            max-height: 80dvh;
            overflow: hidden;
            overflow-y: auto;
        }
    }
</style>